import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';
import Moment from 'moment';

export const baseURI = '/recaudacion/sectores-de-infracciones/';

/**
 * GET SectoresDeInfracciones
 * @param {Object} params
 * @returns {Promise<Array<object>>}
 */
export const getSectoresDeInfracciones = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return { results: [] };
  }
};

/**
 * GET SectorDeInfraccion
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getSectorDeInfraccion = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST SectorDeInfraccion
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postSectorDeInfraccion = async (values) => {
  try {
    const valuesEntidad = values;
    valuesEntidad.entidad = 1;
    const response = await API.post(baseURI, valuesEntidad);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH SectorDeInfraccion
 * @param {number} id
 * @param {object} _values
 * @returns {Promise<object|boolean>}
 */
export const patchSectorDeInfraccion = async (id, _values) => {
  try {
    const values = {
      ..._values,
      fecha_de_ultimo_movimiento: Moment(),
    };
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
/**
 * DELETE SectorDeInfraccion
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteSectorDeInfraccion = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}/`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
